export default __webpack_public_path__ + "static/media/uiet_mark.1ac815c3.jpeg";